var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefundTit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 32,
    viewBox: "0 0 20 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    clipPath: "url(#clip0_2647_3778)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.135 0.865234H0.865112V12.7337H19.135V0.865234Z",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.135 12.7334H0.865112V28.9099H19.135V12.7334Z",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.5813 28.9102V31.5226",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.5658 28.9102V31.5226",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.13489 5.10352V7.63812",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M4.13489 16.4883V22.4744",
    stroke: "#1D1D1B",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2647_3778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 31.5225,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefundTit2);
export default __webpack_public_path__ + "static/media/icon_refund_tit2.fcc83c019aeec56a6cf03df77a8bfdc6.svg";
export { ForwardRef as ReactComponent };